<div class="alert text-ellipsis text-wrap" [ngClass]="[typeClass, marginClass]">
  <ng-content></ng-content>
</div>
